export { default, handle } from "./routes/$slug.tsx";